import React, { useCallback, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";
import "./TestimonialSection.css";
import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import TestimonialsBox from "./TestimonialsBox";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function TestimonialSection() {
  const { RendomTokenfetch } = useAuth();
  const [TestimonialData, setTestimonialData] = useState([]);
  const [loading, setLoading] = useState(false);

  const FetchTestimonialData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${WebsiteAPIurl}testimonialAPI.php`, {
        headers: {
          Authorization: RendomTokenfetch,
        },
      });
      if (response.data.status === "1") {
        setTestimonialData(response.data.testimonialdata);
      } else {
        setTestimonialData([]);
      }
    } catch (error) {
      console.error("Error fetching slider:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch]);

  useEffect(() => {
    FetchTestimonialData();
  }, [FetchTestimonialData]);

  if (loading) {
    // return <APIDataFetchLoader />;
  }
  return (
    <>
      <section
        className="testimonials section-padding"
        style={{
          backgroundImage: "url('images/LP-37Banner.jpg')",
          backgroundPosition: "center center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="container">
          <div className="row section-title">
            <div className="col col-md-8 col-md-offset-2">
              <h2 className="">Testimonials</h2>
              <p>
                We deliver true results, focusing on strategic decisions and
                practical actions tailored to our clients' unique reality. We
                engage all levels of an organization from day one.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col col-md-12">
              <div className="testimonials-slider">
                <Swiper
                  modules={[Autoplay]}
                  spaceBetween={20}
                  slidesPerView={2}
                  // autoplay={{
                  //   delay: 3000,
                  //   disableOnInteraction: false,
                  // }}
                  speed={2000}
                  // loop={TestimonialData.length > 1}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 1,
                    },
                    1024: {
                      slidesPerView: 2,
                    },
                    1440: {
                      slidesPerView: 2,
                    },
                  }}
                  className=""
                >
                  {TestimonialData.length > 0 &&
                    (TestimonialData.length === 1
                      ? [...TestimonialData, ...TestimonialData]
                      : TestimonialData
                    ).map((val, index) => (
                      <SwiperSlide key={index}>
                        <TestimonialsBox testiData={val} />
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
